export default {

    isLoggedIn(state){
        if(state.currentUser&& state.token) return true;
        return false;
    }

}